module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Ward List\" baCardClass=\"with-scroll\">\n        <ward-list></ward-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New Ward\" baCardClass=\"with-scroll\">\n        <ward-form></ward-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/wards/ward.component.html
// module id = 880
// module chunks = 8